<style lang="stylus">
    /deep/ .MsgBox-container{
        text-align: center;
    }
    .BindPhone-mask
      modal-mask()
      z-index 100
      .bindphone-box
        position absolute
        left 50%
        top 50%
        padding-bottom 20px
        transform translate(-50%, -50%)
        background-color #fff
        z-index 30
        border-radius 5px
        box-shadow $modal-shadow
        width 360px
        max-width 100%
        overflow auto
        user-select none
        .bindphone-title
          z-index 30
          position relative
          width 100%
          padding 12px 0 12px 20px
          background-color var(--bg-color-white)
          color $modal-title-textcolor
          font-size $modal-title-textsize
          border-top-left-radius 5px
          border-top-right-radius 5px
          cursor move
          user-select none
          .item-icon
              width 25px
              height 21px
              left 24px
              top 10px
          .title-text
              font-weight: 600
              font-size 14px
              line-height 16px
          .title-close
              position absolute
              top 9px
              right 15px
              width 25px
              height 25px
              cursor pointer
              >svg
                  position absolute
                  top 50%
                  left 50%
                  transform translate(-50%, -50%)
                  color: var(--svg-color-gray-42)
                  width 17px
                  height 17px
          .inline-block
            display inline-block
    .BindPhone-container
        padding 20px 24px
        .BindPhone-line
            display flex
            justify-content space-around
            align-items center
            font-size 12px
            line-height 25px
            >div
                line-height 24px
                font-size 13px
                color #333
            img
                width 50px
                height 50px
                margin-right 8px
    .bindphone-btnbox
        margin auto
        display flex
        justify-content flex-end
        align-items center
        padding-right 24px
        .dialog-btn-ok
            background-color var(--themeColor)
            color #fff
            line-height unset
        .dialog-btn-cancel{
          line-height unset
        }
        div
            padding 5px 20px
            min-width 72px
            background-color #EBEDF1
            color #000
            border-radius 6px
            font-size 12px
            text-align center
            user-select none
            cursor pointer

    .BindPhone-form
        padding: 0 24px;
        .ivu-input-large
            border: 1px solid $box-bordercolor = rgba(0, 0, 0, 0.06);
            border-radius: $box-radius;
            font-size: 14px;
            padding: 6px 7px;
            height: 38px;
        .ivu-form-item-required .ivu-form-item-label
            &:before
                display: none;
        .ivu-form-label-top .ivu-form-item-label
            padding: 0 0 16px 0;
        .code-input
            .ivu-input
                padding-right 120px;
            .ivu-input-suffix
                width: auto;
        .code-btn
            margin-top 5px
            margin-right 5px
            width: 100px;
            height: 28px;
            background: rgba(1, 127, 255, 0.1);
            border-radius: 4px;
            font-size: 12px;
            line-height: 28px;
            text-align: center;
            color: var(--themeColor);
            cursor: pointer;
            &:hover:not(.active){
              background-color: rgba(1, 127, 255, 0.12);
            }
            &.active
                background: #fff;
                color: #999999;
                cursor: unset
</style>

<template>
    <div class="BindPhone-mask">
        <div class="bindphone-box">
            <div class="bindphone-title">
                <p class="title-text">{{ $t("title") }}</p>
                <div class="title-close" @click="cancel()" @mousedown.stop>
                    <iconSymbol name="Del" />
                </div>
            </div>
            <div class="BindPhone-container">
                <div class="BindPhone-line">
                    <img src="../../assets/img/dialog/bindphone/bind-phone.svg" alt="" />
                    <p>{{ $t($store.state.bindPhoneDialog.fromBtn) }}</p>
                </div>
            </div>
            <div class="BindPhone-form">
                <Form :model="form" label-position="top">
                    <FormItem prop="phone" :label="$t('phone')">
                        <Input v-model="form.phone" :maxlength="11" size="large"></Input>
                    </FormItem>
                    <FormItem prop="code" :label="$t('code')">
                        <Input v-model="form.code" :maxlength="6" size="large" class="code-input">
                            <div slot="suffix" @click="getPhoneCode" class="code-btn" :class="{ active: getCheckCodeText != $t('getCode') }">
                                {{ getCheckCodeText }}
                            </div>
                        </Input>
                    </FormItem>
                </Form>
            </div>
            <div class="bindphone-btnbox">
                <div class="dialog-btn-ok" @click="confirm()">确认</div>
                <div class="dialog-btn-cancel" @click="cancel()">取消</div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Inject, Vue } from "vue-property-decorator";
    import { getHttpErrorCode } from "@/public/utils/tool.js";
    import md5 from "md5.js";
    @Component({})
    export default class MsgBox extends Vue {
        @Inject()
        ["showMessage"];
        form = {
            phone: "",
            code: "",
        };
        get userInfo() {
            return this.$store.getters.apiParam;
        }
        get shareId() {
            return this.$store.state.bindPhoneDialog.shareId;
        }
        get fromBtn() {
            return this.$store.state.bindPhoneDialog.fromBtn;
        }
        getCheckCodeText: any = "";
        timer = NaN;
        sucessCb() {
            this.$edMessage.success(this.$t("codeSendSuccess"));
            this.getCheckCodeText = "60" + this.$t("requestCodeAgain");
            this.timer = setInterval(() => {
                if (parseInt(this.getCheckCodeText) === 0) {
                    clearInterval(this.timer);
                    this.getCheckCodeText = this.$t("getCode");
                    return;
                }
                this.getCheckCodeText = (parseInt(this.getCheckCodeText) - 1 || 0) + <string>this.$t("requestCodeAgain");
            }, 1000);
        }
        getPhoneCode() {
            if (this.form.phone == "") {
                this.$edMessage.warning(this.$t("nullPhone"));
                return;
            }
            if (!/^1[3456789]\d{9}$/.test(this.form.phone)) {
                this.$edMessage.error(this.$t("errorPhone"));
                return;
            }
            let a = new md5().update(this.form.phone).digest("hex");
            let b = new md5().update(a.substr(17, 8)).digest("hex");
            let c = a.substr(a.length - 10, 10);
            this.$edApi
                .getPhoneCode({
                    user_id: this.userInfo.id,
                    captcha_type: 1,
                    mobile: this.form.phone,
                })
                .then(() => {
                    this.sucessCb();
                })
                .catch((err) => {
                    const errorCode = getHttpErrorCode(err);
                    if (errorCode === "231200" || errorCode === "231201" || errorCode === "231203") {
                        this.$edMessage.error(this.$t("requestTooFrequent"));
                    } else {
                        this.$edMessage.error(this.$t("fail"));
                    }
                });
        }
        confirm() {
            if (!this.form.phone) {
                this.$edMessage.error(this.$t("nullPhone"));
                return;
            }
            if (!/^1[3456789]\d{9}$/.test(this.form.phone)) {
                this.$edMessage.error(this.$t("errorPhone"));
                return;
            }
            if (!/\d{6}/.test(this.form.code)) {
                this.$edMessage.error(this.$t("errorCode"));
                return;
            }
            let params = {
                token: this.userInfo.token,
                id: this.userInfo.id,
                mobile: this.form.phone,
                code: this.form.code,
            };
            this.$edApi
                .bindUserPhone(params)
                .then(() => {
                    this.$store.dispatch("getUserInfo");
                    if (this.fromBtn === "shareBtn") {
                        if (this.shareId) {
                            this.$bus.$emit("toShowShare");
                        } else {
                            this.$bus.$emit("shareFile", false, true, null);
                        }
                    } else if (this.fromBtn === "publishBtn") {
                        this.$bus.$emit("toPublish");
                    } else if (this.fromBtn === "publishLibraryBtn") {
                        const dbAndTable = this.$store.state.ui.selectLibrary;
                        this.$bus.$emit("publishLibrary", dbAndTable[2]);
                    }
                    this.cancel();
                })
                .catch((err) => {
                    const errorCode = getHttpErrorCode(err);
                    if (errorCode === "1904") {
                        this.showMessage({
                            sponsor: "bindPhone",
                            type: 0,
                            uniqueListenr: true,
                            content: this.$t(`${this.fromBtn}HasBind`),
                        });
                    } else if (errorCode === "1300") {
                        this.$edMessage.error(this.$t("errorCode"));
                    } else {
                        this.$edMessage.error(this.$t("fail"));
                    }
                });
        }
        cancel() {
            this.$store.commit("toHidePhoneDialog");
            clearInterval(this.timer);
        }
        mounted() {
            this.getCheckCodeText = this.$t("getCode");
            this.$bus.$on("msgOperation-bindPhone", async (data) => {
                if (data.sponsor == "bindPhone" && data.data) {
                    console.log(this.fromBtn);
                    // 手机号和验证码存入临时用户信息
                    this.$store.commit("setUserInfoTemp", {
                        mobile: this.form.phone,
                        auth_code: this.form.code,
                    });
                    // 来自分享按钮
                    if (this.fromBtn === "shareBtn") {
                        if (this.shareId) {
                            let params = {
                                token: this.userInfo.token,
                                id: this.userInfo.id,
                                mobile: this.form.phone,
                                auth_code: this.form.code,
                                share_id: this.shareId,
                            };
                            this.$edApi
                                .verifyPhone(params)
                                .then(() => {
                                    this.$bus.$emit("toShowShare");
                                })
                                .catch(() => {
                                    this.$edMessage.error(this.$t("fail"));
                                });
                        } else {
                            this.$bus.$emit("shareFile", false, true, {
                                mobile: this.form.phone,
                                auth_code: this.form.code,
                            });
                        }
                    }
                    // 來自发布按钮
                    else if (this.fromBtn === "publishBtn") {
                        this.$bus.$emit("toPublish");
                        // 来自符号库发布按钮
                    } else if (this.fromBtn === "publishLibraryBtn") {
                        const dbAndTable = this.$store.state.ui.selectLibrary;
                        this.$bus.$emit("publishLibrary", dbAndTable[2]);
                    }
                    this.cancel();
                } else if (data.sponsor == "bindPhone" && !data.data) {
                    this.getCheckCodeText = this.$t("getCode");
                    this.form = {
                        phone: "",
                        code: "",
                    };
                    clearInterval(this.timer);
                }
            });
        }
    }
</script>

<i18n>
{
    "zh": {
        "phone": "手机号",
        "code": "验证码",
        "getCode": "发送验证码",
        "errorPhone": "手机号错误",
        "nullPhone": "请输入手机号",
        "errorCode": "验证码错误",
        "requestTooFrequent": "请求过于频繁，请稍后再试",
        "codeSendSuccess": "验证码发送成功",
        "requestCodeAgain": "稍后重新获取",
        "fail": "验证失败",
        "shareBtn": "根据网络安全需要，请先绑定手机号，再进行文件分享。",
        "publishBtn": "根据网络安全需要，请先绑定手机号，再进行文件发布。",
        "publishLibraryBtn": "根据网络安全需要，请先绑定手机号，再进行符号库发布。",
        "confirm": "确定",
        "cancel": "取消",
        "title": " 绑定手机号",
        "shareBtnHasBind":  "此手机号已绑定其他账号，您可以继续使用该手机号进行分享操作，但是仅能分享一次 <br/><br/>（注：下次分享时您还需绑定手机号，若您需要绑定此手机号，请前往用户中心将当前账号与此手机号先前绑定的账号进行合并）",
        "publishBtnHasBind":  "此手机号已绑定其他账号，您可以继续使用该手机号进行发布操作，但是仅能发布一次 <br/><br/>（注：下次发布时您还需绑定手机号，若您需要绑定此手机号，请前往用户中心将当前账号与此手机号先前绑定的账号进行合并）",
        "publishLibraryBtnHasBind":  "此手机号已绑定其他账号，您可以继续使用该手机号进行发布操作，但是仅能发布一次 <br/><br/>（注：下次发布时您还需绑定手机号，若您需要绑定此手机号，请前往用户中心将当前账号与此手机号先前绑定的账号进行合并）"
    },
    "en": {
        "phone": "Phone",
        "code": "Code",
        "getCode": "Get code",
        "errorPhone": "Wrong phone number",
        "nullPhone": "Please enter the phone number",
        "errorCode": "Wrong verification code",
        "requestTooFrequent": "Too many requests. Please try again later.",
        "codeSendSuccess": "Verification code has been sent successfully.",
        "requestCodeAgain": "seconds later, you can then resend code.",
        "fail": "FAIL",
        "shareBtn": "According to the Cyber Security Law, you need to bind your phone number before sharing files.",
        "publishBtn": "According to the Cyber Security Law, you need to bind your phone number before publish files.",
        "publishLibraryBtn": "According to the Cyber Security Law, you need to bind your phone number before publish symbol library.",
        "confirm": "OK",
        "cancel": "Cancel",
        "title": " Bind mobile phone",
        "shareBtnHasBind": "The phone number has been bound to one account. Do you want to confirm this share with this phone number? If you want to bind the phone number to the existing account, please go to Account Center to set.",
        "publishBtnHasBind": "The phone number has been bound to one account. Do you want to confirm this publish with this phone number? If you want to bind the phone number to the existing account, please go to Account Center to set.",
        "publishLibraryBtnHasBind": "The phone number has been bound to one account. Do you want to confirm this publish with this phone number? If you want to bind the phone number to the existing account, please go to Account Center to set."
    }
}
</i18n>
